
<!-- Loading screen mientras se verifica la autenticación -->
<div *ngIf="isAuthLoading" class="auth-loading-container">
  <div class="auth-loading-content">
    <div class="logo-loading">
      <img src="assets/img/orbis/Logo_PRINCIPAL.png" alt="Logo" class="loading-logo">
    </div>
    <div class="loading-spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
    <p class="loading-text">Verificando acceso...</p>
  </div>
</div>

<!-- Contenido principal de la aplicación -->
<div *ngIf="!isAuthLoading">
  <router-outlet></router-outlet>
</div>


